// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HxXOVDEn{background:var(--theme-background);flex:0 0 auto;padding:0 var(--space-roomy)}`, "",{"version":3,"sources":["webpack://./src/page-components/app/shell/AppFooter.module.scss"],"names":[],"mappings":"AAAA,UACE,kCAAA,CACA,aAAA,CACA,4BAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `HxXOVDEn`
};
export default ___CSS_LOADER_EXPORT___;
